<template>
    <modal
        :saveAction="okAction"
        :title="title"
        :id="id"
        :actionButtons="true"
        size="lg"
        :closeButton="false"
        @shown="shown() "
    >
        <template slot="modal-header">
            <div></div>
        </template>

        <div class="row" style="height:77vh; overflow-y:auto">
            <div class="col" id="appendHere">
                <div class="mb-5" v-for="(appointment, appointmentsIndex) in appointments" :key="appointmentsIndex">
                    <div class="header m-0">
                        <div class="header-body">
                            <div class="row align-items-center p-0">
                                <div class="col-auto">
                                    <div class="invisible">
                                        <flat-pickr
                                            v-model="appointment.appointmentAt"
                                            placeholder="Select date"
                                            :config="calendarOptions"
                                            class="position-absolute"
                                            :ref="'datePickerWrap'+appointmentsIndex"
                                        ></flat-pickr>
                                    </div>
                                    <h1 class="header-title">
                                        {{$t('Appointment')}} #{{appointmentsIndex + 1}} /
                                        <a
                                            href="#"
                                            :id="'calendar-' + appointmentsIndex"
                                            @click.prevent="openDatePicker(appointmentsIndex)"
                                            class="text-info"
                                        >
                                            {{ appointment.appointmentAt | moment('D MMMM, dddd') }}
                                            <i
                                                class="fe fe-calendar"
                                            ></i>
                                        </a>
                                        {{ appointment.startAt | moment('LT')}} - {{ appointment.endAt | moment('LT')}}
                                    </h1>
                                </div>

                                <div class="col"></div>
                                <div class="col-auto">
                                    <button
                                        class="btn btn-sm btn-white"
                                        v-if="appointment.services.length==0"
                                        @click="removeAppointment(appointmentsIndex)"
                                    >
                                        <i class="fe fe-trash" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center">
                        <div class="col-auto p-2"></div>
                    </div>

                    <div
                        class="row align-items-center mt-3"
                        v-for="(service, serviceIndex) in appointment.services"
                        :key="serviceIndex"
                    >
                        <div class="col-6">
                            {{ service.label }}
                            <div class="text-muted small">
                                {{ service.duration | duration}}
                                ({{ service.bufferDuration | duration}})
                                <money class="ml-4" :value="service.price" />
                            </div>
                        </div>
                        <div class="col-3">
                            <team-select
                                :params="providersParams(service)"
                                @change="fetchAppointments(service);"
                                v-model="service.user"
                                idOnly
                            ></team-select>
                        </div>
                        <div class="col-auto">
                            <hours
                                v-model="service.startAt"
                                :blocked="findSlots(service)"
                                :schedule="workingHours(service)"
                                :base="appointment.appointmentAt"
                            ></hours>
                        </div>

                        <div class="col-auto">
                            <div class="invisible">
                                <flat-pickr
                                    v-model="service.moveTo"
                                    @on-change="moveTo()"
                                    placeholder="Select date"
                                    :config="calendarOptions"
                                    class="position-absolute"
                                    :ref="'datePickerWrap'+appointmentsIndex +''+ serviceIndex"
                                ></flat-pickr>
                            </div>
                            <button class="btn btn-white" @click="openDatePicker(appointmentsIndex+''+serviceIndex)">
                                <i class="fe fe-calendar" :id="'calendar-' + appointmentsIndex+''+serviceIndex " />
                            </button>
                        </div>
                    </div>
                    <div class="row" v-if="1>2">
                        <div class="col text-center mt-4 mb-4">
                            <button class="btn btn-info btn-sm" @click="addService(appointmentsIndex)">
                                <i class="fe fe-plus" />
                                {{$t('Add service')}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center p-2">
                        <button class="btn btn-white" @click="addAnotherAppointment()">
                            <i class="fe fe-plus" />
                            {{$t('Add another appointment')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal.vue";
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import TeamSelect from '@/components/TeamSelect.vue';
import Money from '@/components/Money';
import DatePicker from '@/components/DatePicker';
import Hours from "@/components/Hours.vue";
import User from '@/components/User'
import duration from '@/filters/duration'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';


export default {
    props: ['id', 'data', 'saveAction'],
    mixins: [modalMixins],
    filters: { duration },
    components: {
        flatPickr,
        Hours,
        Modal,
        User,
        Money,
        DatePicker,
        TeamSelect,
    },
    computed: {
        ...mapGetters('my-team', { getItemById: 'get' }),
        ...mapGetters('appointment', { findAppointments: 'find', appointment: 'get' }),

    },
    data() {
        return {
            date: null,
            selectedServices: [],
            appointments: [],
            title: '',
            calendarOptions: {
                wrap: true,
                altFormat: 'F j, Y',
                dateFormat: "F j, Y",
                ariaDateFormat: 'd.m.Y',

            },
        }
    },
    watch: {
        'appointments': {

            handler(newValue) {
                newValue.forEach(appointment => {
                    if (appointment.services.length == 0) return;
                    appointment.startAt = appointment.services[0].startAt;
                    let lastService = appointment.services[appointment.services.length - 1];

                    // loop error comes here
                    // appointment.endAt = this.$moment(lastService.startAt).add(lastService.duration + lastService.bufferDuration, 'minutes');
                    let endAt = this.$moment(lastService.startAt).add(lastService.duration + lastService.bufferDuration, 'minutes').format();
                    appointment.endAt = endAt;

                    appointment.services.forEach(service => {
                        this.fetchAppointments(service);
                    });
                })
            },
            deep: true
        }

    },
    methods: {
        ...mapActions('appointment', ['find', 'create', 'patch', 'remove']),
        openDatePicker(id) {
            const flatPickrInstance = this.$refs['datePickerWrap' + id][0].fp;
            flatPickrInstance._positionElement = window.document.getElementById('calendar-' + id); // eslint-disable-line
            flatPickrInstance.open();
        },
        moveTo(date) {
            this.appointments.forEach(appointment => {
                appointment.services.forEach((service, serviceIndex) => {
                    if (service.moveTo) {
                        // Find appointment with date or create new appointment with date
                        let moveTo = this.$moment(service.moveTo);
                        let appointmentIndex = this.appointments.findIndex(row => {
                            return this.$moment(row.appointmentAt).dayOfYear() == moveTo.dayOfYear()
                        });

                        if (appointmentIndex >= 0) {}
                        else {
                            this.appointments.push({
                                startAt: moveTo,
                                appointmentAt: moveTo.format('YYYY-MM-DD'),
                                services: []
                            });
                            appointmentIndex = this.appointments.length - 1;
                        }
                        service.moveTo = null;
                        this.appointments[appointmentIndex].services.push(service);
                        appointment.services.splice(serviceIndex);
                    }
                })
            });

        },

        providersParams(service) {

            const dayOfweeks = {
                1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday', 7: 'sunday'
            }
            const dayOfweek = dayOfweeks[this.$moment(service.appointmentAt).isoWeekday()];
            return {
                query: {
                    // 'schedule.dayOfWeek': dayOfweek,
                    treatments: { $in: [service._id] }
                }
            }
        },
        workingHours(service) {
            if (!service.user) return;
            let user = this.getItemById(service.user);
            return user.schedule;
        },
        removeAppointment(idx) {

            let appointment = this.appointments[idx];

            if (appointment._id) {
                this.remove(appointment._id);
            }
            this.appointments.splice(idx, 1);

        },

        removeService(appointmentIndex, idx) {
            this.appointments[appointmentIndex].services.splice(idx, 1);
        },
        addService(appointmentIndex) {
            this.appointments[appointmentIndex].services.push({

            });
        },
        addAnotherAppointment() {
            return this.appointments.push({
                startAt: this.$moment(),
                appointmentAt: this.$moment().format('YYYY-MM-DD'),
                services: []
            });

        },
        shown() {


            if (this.data.appointments.length > 0) {
                this.appointments = [];
                let unappointedServices = [];

                let appointmentIds = JSON.parse(JSON.stringify(this.data.appointments));
                let appointments = this.findAppointments({ query: { _id: { $in: appointmentIds } } }).data;
                appointments.forEach(appointment => {
                    let item = {
                        _id: appointment._id,
                        startAt: appointment.startAt,
                        endAt: appointment.endAt,
                        appointmentAt: appointment.startAt,
                        services: []
                    };

                    this.data.treatments.forEach(service => {
                        if (service.appointmentId == appointment._id) {
                            item.services.push(service);
                        }

                    });

                    this.appointments.push(item);
                });

                this.data.treatments.forEach(service => {
                    if (!service.appointmentId) {
                        unappointedServices.push(service);
                    }
                });
                if (unappointedServices.length > 0) {
                    this.addAnotherAppointment();
                    this.appointments[this.appointments.length - 1].services = unappointedServices;
                }

            } else {
                this.appointments = [];
                this.addAnotherAppointment();
                this.createInitial();
            }

        },
        createInitial() {

            this.data.treatments.forEach(treatment => {
                this.appointments[0].services.push(treatment);
            });

        },

        okAction() {
            this.errors = {};
            let appointmentIds = [];
            let promises = [];

            this.appointments.forEach(appointment => {
                let promise = this.save(appointment).then(data => {
                    appointmentIds.push(data._id);
                    appointment.services.forEach(service => {
                        service.appointmentId = data._id;
                    });
                    return data;
                }).catch(e => {
                    this.errors = e.errors;
                });

                promises.push(promise);
            });

            Promise.all(promises).then(result => {
                this.data.appointments = appointmentIds;
            });
            this.$root.$emit('bv::hide::modal', this.id);
        },

        save(appointment) {

            let data = {
                startAt: appointment.startAt,
                endAt: appointment.endAt,
                repeat: appointment.repeat,
                customerId: this.$route.params.id,
                services: appointment.services.map(service => {
                    return {
                        treatmentId: service._id,
                        userId: service.user._id,
                        startAt: service.startAt,
                        duration: service.duration
                    }
                }),
                notes: appointment.notes
            };
            let promise;

            if (appointment._id) {
                promise = this.patch([appointment._id, data]);
            } else {
                promise = this.create(data);
            }

            return promise;

        },


        fetchAppointments(service) {


            if (!service) return false;

            let queryParams = {
                query: {
                    'services.userId': service.user,
                    startAt: {
                        $gt: this.$moment(service.startAt).startOf('day'),
                        $lt: this.$moment(service.startAt).endOf('day'),
                    }
                }
            };

            this.find(queryParams);
        },
        findSlots(service) {
            if (!service.user) return false;
            let queryParams = {
                query: {
                    'services.userId': service.user,
                    status: { $nin: ['completed','cancelled'] },
                    startAt: {
                        $gt: this.$moment(service.startAt).startOf('day'),
                        $lt: this.$moment(service.startAt).endOf('day'),
                    }
                }
            };

            let result = this.findAppointments(queryParams).data;
            let disabledHours = [];
            result.forEach(appointment => {
                appointment.services.forEach(serviceItem => {
                    disabledHours.push(
                        {
                            start: serviceItem.startAt,
                            end: this.$moment(serviceItem.startAt).add(service.duration, 'minute')
                        }
                    );
                })
            });
            return disabledHours;
        },


    }
}
</script>
